import { Fragment, type FC, type ReactNode } from "react";
import DataTable from "./DataTable";

type Themes = "stripes" | "separatorsTop" | "separators" | "none";

interface DataTableProps {
  className?: string;
  header: ReactNode | ReactNode[];
  data?: ReactNode[][];
  columnFlex?: string[] | string[][];
  hideRowPadding?: boolean;
  theme?: Themes;
}

/**
 * Simple data table, with a header as react nodes and
 *
 * @deprecated
 */
const DataDrivenTable: FC<DataTableProps> = (props) => {
  const { header: headerContent, data, className, columnFlex, hideRowPadding, theme } = props;

  const headerCells = Array.isArray(headerContent) ? headerContent : [headerContent];
  let header: ReactNode;
  if (!headerCells) {
    header = null;
  } else {
    header = (
      <DataTable.CellRow>
        {headerCells.map((child, index) => (
          <DataTable.Cell key={index}>{child}</DataTable.Cell>
        ))}
      </DataTable.CellRow>
    );
  }

  return (
    <DataTable.Table
      className={className}
      noPadding={hideRowPadding}
      columnFlex={columnFlex}
      header={header}
      theme={theme}
    >
      {data &&
        data.map((row, index) => {
          return (
            <Fragment key={index}>
              <DataTable.CellRow>
                {row.map((cell, cellIndex) => (
                  <DataTable.Cell key={cellIndex}>{cell}</DataTable.Cell>
                ))}
              </DataTable.CellRow>
            </Fragment>
          );
        })}
    </DataTable.Table>
  );
};

export default DataDrivenTable;
